import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('EventScreenTemplate').create(({ theme }) => ({
  root: {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgb(6, 7, 7)',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
    overflowX: 'hidden',
    position: 'relative',
    zIndex: 1,

    h1: {
      fontFamily: 'Inter',
      fontWeight: 600,
      fontSize: theme.sizes.texts.fontSize.xl,

      lineHeight: '40px',
      textAlign: 'center',
      marginTop: '4px',
      color: theme.colors.text.primary,
    },
  },

  newsImage: {
    position: 'fixed',
    zIndex: 2,
    width: '100%',
    // maxWidth: '520px',
    overflowX: 'hidden',
    top: '2vh',
    alignSelf: 'center',
  },

  contentWrapper: {
    position: 'absolute',
    display: 'flex',
    width: '90%',
    alignSelf: 'center',
    flexDirection: 'column',
    padding: '24px 20px',
    borderRadius: '16px',
    backgroundColor: 'rgb(22, 22, 24, 30%)',
    backdropFilter: 'blur(20px)',
    top: '200px',
    zIndex: 6,
    paddingBottom: '52px',
  },

  headingAndDescriptionWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '10px',
    h1: {
      marginBottom: '0px',
    },
  },

  description: {
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: '13px',
    lineHeight: '20px',
    color: 'rgba(250, 252, 255, 0.65)',

    p: {
      margin: '8px 0px',
    },
  },

  infoCard: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    backgroundColor: 'rgba(240, 245, 250, 0.05)',
    borderRadius: '12px',
  },

  infoItem: {
    display: 'flex',
    minHeight: '80px',
    alignItems: 'center',
    padding: '0px 24px',
    gap: '24px',
  },

  infoTextWrapper: {
    padding: '12px 0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    h2: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: theme.sizes.texts.fontSize.m,
      lineHeight: theme.sizes.texts.lineHeight.l,

      color: theme.colors.text.primary,
      margin: '0px',
    },
    p: {
      fontFamily: 'Inter',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: theme.sizes.texts.lineHeight.s,

      color: 'rgba(112, 117, 121, 1)',
      margin: '0px',
    },
  },

  iconWrapper: {
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
      height: '100%',
    },
  },

  notation: {
    fontFamily: 'Inter',
    fontWeight: 350,
    fontSize: '13px',
    lineHeight: '18px',
    color: theme.colors.text.secondary,
    paddingBottom: '52px',

    p: {
      margin: '8px 0px',
    },
  },

  button: {
    width: '90%',
    height: '52px',
    zIndex: 5,
  },
}))
